// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"3395fb16","362":"01029b8a"}[chunkId] + ".chunk.css";
};